import {EMenuId} from './constants';

export default {
  title: 'The heart of digital communications',
  navigation: {
    [EMenuId.HOME]: 'Home',
    [EMenuId.TRIGGERS]: 'Scripts',
    [EMenuId.BROADCASTS]: 'Broadcasts',
    [EMenuId.DIALOGS]: 'Dialogs',
    [EMenuId.SUBSCRIBERS]: 'Audience',
    [EMenuId.CASCADES]: 'Cascades',
    [EMenuId.CHANNELS]: 'Channels',
    [EMenuId.MESSAGE_MATCHERS]: 'Templates',
    [EMenuId.ANALYTICS]: 'Analytics',
    [EMenuId.ANALYTICS_MESSAGES]: 'Messages',
    [EMenuId.ANALYTICS_SUMMARY_REPORT]: 'Summary report',
    [EMenuId.ANALYTICS_MESSAGE_MATCHERS]: 'Template statistics',
    [EMenuId.PROFILE]: 'Profile',
    [EMenuId.MY_PROFILE]: 'My profile',
    [EMenuId.CLIENTS]: 'Company clients',
    [EMenuId.COMPANY_LEAD_CLIENTS]: 'Leads',
    [EMenuId.SUPPORT_CLIENTS]: 'Client',
    [EMenuId.COMPANY_AGENT_CLIENTS]: 'Agents',
    [EMenuId.COMPANY_PROFILE]: 'Company profile',
    [EMenuId.COMPANY_NEWS]: 'Company news',
    [EMenuId.HELP]: 'Help',
    [EMenuId.NOTIFICATIONS]: 'Event log',
    [EMenuId.SIGN_OUT]: 'Sign out',
    [EMenuId.INTEGRATION]: 'Integration',
    [EMenuId.CORRECTIONS]: 'Corrections',
    [EMenuId.AGENT_PAYMENTS]: 'Client payments',
    [EMenuId.AGENT_CLIENTS]: 'My clients',
    [EMenuId.AGENT_PROFILE]: 'Company profile',
    [EMenuId.TARIFFS]: 'Tariff catalog',
  },
};
